import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect as s, useState as o } from "react";
import { disposables as t } from '../utils/disposables.js';
function p() {
  var _o = o(t),
    _o2 = _slicedToArray(_o, 1),
    e = _o2[0];
  return s(function () {
    return function () {
      return e.dispose();
    };
  }, [e]), e;
}
export { p as useDisposables };